import { BrButton, BrCard, BrMessage } from '@govbr-ds/react-components';
import styles from './diefCfemCards.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import arrematacaoImage from '../../../assets/arrematacao.png';
import primeiroAdquirenteImage from '../../../assets/primeiro-adquirente.png';
import titularArrendatarioImage from '../../../assets/titular-ou-arrendatario.png';
import { useBackEndRequests } from '../lib/backEndRequests';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import CustomLoading from '../../../components/customLoading/customLoading';
import { isCPForCNPJ } from '../../../utils/formatCNPJOrCPF';
import unhappyFace from '../../../assets/unhappy-face.png';
import ErrorMessage from '../../../components/errorMessage/errorMessage';
import { useNotificacao } from '../../../hooks/useNotificacao';
import { Button, Modal } from 'react-dsgov';
import { ENaturezaDocumentacao } from '../../../enums/ENaturezaDocumentacao';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';
import { incluirSentryIdMsgErro } from 'utils/incluirSentryIdMsgErro';

function DiefCfemCards() {
  const [userCpfCnpj, setUserCpfCnpj] = useState<string | null>(sessionStorage.getItem('userCpfCnpj'));
  const [isPessoaNaoCadastrada, setIsPessoaNaoCadastrada] = useState(false);
  const [isPrimeiroAdquirente, setIsPrimeiroAdquirente] = useState(false);
  const [isCnpjFilial, setIsCnpjFilial] = useState(false);
  const [mostraAvisoFilial, setMostraAvisoFilial] = useState(false);
  const [hasErrorGetCnpjNaturezaId, setHasErrorGetCnpjNaturezaId] = useState(false);

  const [isModalTitularArrendatario, setIsModalTitularArrendatario] = useState(false);

  const navigate = useNavigate();
  const mostrarNotificacao = useNotificacao();

  const { getExistsAndIsPrimeiroAdquirente, getIsTitularArrendatario, getCnpjNaturezaId } = useBackEndRequests();

  const {
    data: existsAndIsPrimeiroAdquirenteData,
    isLoading,
    error,
  } = useQuery<any, IErrorWithSentryId>({
    queryKey: ['existsAndIsPrimeiroAdquiretneQuery', userCpfCnpj],
    queryFn: () => getExistsAndIsPrimeiroAdquirente(userCpfCnpj || ''),
    refetchOnWindowFocus: false,
    enabled: !!userCpfCnpj,
    retry: isPessoaNaoCadastrada,
  });

  const {
    data: cnpjNaturezaId,
    isLoading: isLoadingCnpjNaturezaId,
    error: errorCnpjNaturezaId,
  } = useQuery<any, IErrorWithSentryId>({
    queryKey: ['isCnpjFilial ', userCpfCnpj],
    queryFn: () => getCnpjNaturezaId(userCpfCnpj || ''),
    refetchOnWindowFocus: false,
    staleTime: 0,
    enabled: !!userCpfCnpj,
    retry: false,
  });

  const notificarErroPrimeiroAdquirente = () => {
    mostrarNotificacao({
      tipo: 'warning',
      conteudo:
        'Cadastre-se ou atualize os dados no Sistema de Dados Cadastrais como primeiro adquirente e aguarde 1 dia para a validação.',
    });
  };

  const notificarErroConsultaApiCnpj = () => {
    if (!errorCnpjNaturezaId) return;
    if (errorCnpjNaturezaId?.status === 404) {
      mostrarNotificacao({
        tipo: 'danger',
        conteudo:
          'CNPJ não localizado na base de consulta ao Cadastro Nacional da Pessoa Jurídica, favor verificar o cadastro.',
      });
    } else {
      mostrarNotificacao({
        tipo: 'danger',
        conteudo: 'Erro ao consultar a natureza do CNPJ, tente novamente mais tarde.',
        ...(errorCnpjNaturezaId && { complementoSentryId: errorCnpjNaturezaId }),
      });
    }
  };

  useEffect(() => {
    setUserCpfCnpj(sessionStorage.getItem('userCpfCnpj'));
  }, []);

  useEffect(() => {
    if (existsAndIsPrimeiroAdquirenteData) {
      setIsPrimeiroAdquirente(existsAndIsPrimeiroAdquirenteData.isPrimeiroAdquirente);
      sessionStorage.setItem('isPrimeiroAdquirente', existsAndIsPrimeiroAdquirenteData.isPrimeiroAdquirente);
      sessionStorage.setItem('isPessoaNaoCadastrada', 'false');
    } else if (
      (existsAndIsPrimeiroAdquirenteData !== undefined && !existsAndIsPrimeiroAdquirenteData) ||
      error?.status === 404
    ) {
      setIsPessoaNaoCadastrada(true);
      sessionStorage.setItem('isPessoaNaoCadastrada', 'true');
    }
  }, [existsAndIsPrimeiroAdquirenteData, error]);

  useEffect(() => {
    if (errorCnpjNaturezaId) {
      setHasErrorGetCnpjNaturezaId(true);
      return;
    }
    if (!cnpjNaturezaId) return;
    sessionStorage.setItem('naturezaDocumentacao', cnpjNaturezaId.toString());
    setIsCnpjFilial(cnpjNaturezaId === ENaturezaDocumentacao.CNPJ_FILIAL);
  }, [cnpjNaturezaId, errorCnpjNaturezaId]);

  const acessarHastaPublica = async () => {
    if (!userCpfCnpj) return;
    try {
      const data = await getIsTitularArrendatario(userCpfCnpj);
      if (data.isTitularArrendatario) {
        setIsModalTitularArrendatario(true);
      } else {
        navigate('/hasta-publica');
      }
    } catch (error) {
      mostrarNotificacao({
        tipo: 'danger',
        conteudo: 'Erro ao verificar vínculo.' + incluirSentryIdMsgErro(error as IErrorWithSentryId),
      });
    }
  };

  const renderContent = () => {
    if (isLoading || isLoadingCnpjNaturezaId) {
      return <CustomLoading label='Carregando...' />;
    } else if (isPessoaNaoCadastrada) {
      return (
        <div className={styles.naoCadastradoContainer}>
          <img src={unhappyFace} alt='carinha triste' />
          <div className={styles.contentContainer}>
            <h4 className={styles.naoCadastradoTitle}>{isCPForCNPJ(userCpfCnpj ?? '')} não cadastrado no sistema</h4>
            <p className={styles.naoCadastradoText}>
              O {isCPForCNPJ(userCpfCnpj ?? '')} informado como declarante não está cadastrado no sistema. Selecione
              outro representado no combo acima "CPF/CNPJ Representado" ou, caso ache que isto é um erro, verifique com
              a Agência Nacional de Mineração (ANM) se o cadastro está correto. Após o cadastro,{' '}
              <b>aguarde pelo menos 1 dia para a validação dos dados.</b> Para mais informações, clique no botão abaixo
              e acesse o sistema da ANM.
            </p>
          </div>
          <BrButton
            primary
            onClick={() => {
              window.location.href =
                'https://www.gov.br/anm/pt-br/assuntos/exploracao-mineral/Cadastro-para-Requerimentos';
            }}
          >
            Sistema ANM
          </BrButton>
        </div>
      );
    } else if (!existsAndIsPrimeiroAdquirenteData) {
      return <ErrorMessage errorMessage={error?.message || ''} error={error} onClickFunction={() => navigate(0)} />;
    } else {
      return (
        <div>
          {!isPrimeiroAdquirente && (
            <BrMessage
              status='info'
              closable={true}
              message={
                <span>
                  Para acessar a seção Primeiro Adquirente, cadastre-se ou atualize os dados no{' '}
                  <a href='https://app.anm.gov.br/sdc/' target='_blank' rel='noopener noreferrer'>
                    Sistema de Dados Cadastrais
                  </a>{' '}
                  e aguarde 1 dia para a validação.
                </span>
              }
            />
          )}
          <div className={styles.cardContainer}>
            <BrCard
              className={styles.card}
              onClick={() => {
                if (!isCnpjFilial && !hasErrorGetCnpjNaturezaId) {
                  navigate('/titular-ou-arrendatario');
                } else {
                  if (hasErrorGetCnpjNaturezaId) {
                    notificarErroConsultaApiCnpj();
                    return;
                  }
                  setMostraAvisoFilial(true);
                }
              }}
              hover
            >
              <h2 className={styles.cardTitle}>Titular ou Arrendatário</h2>
              <img src={titularArrendatarioImage} alt='' />
              <p className={styles.cardText}>
                <strong>Titular</strong> é a pessoa que detém os direitos minerários e exerce a atividade de mineração
                em seu próprio nome. <strong>Arrendatário</strong> é a pessoa que exerce, a título oneroso ou gratuito,
                a atividade de exploração de recursos minerais com base nos direitos do titular original.
              </p>
              <div className={styles.cardLink}>
                {hasErrorGetCnpjNaturezaId ? (
                  <BrButton onClick={() => notificarErroConsultaApiCnpj()}>
                    Acessar <i className='fas fa-arrow-right' />
                  </BrButton>
                ) : !hasErrorGetCnpjNaturezaId && isCnpjFilial ? (
                  <BrButton onClick={() => setMostraAvisoFilial(true)}>
                    Acessar <i className='fas fa-arrow-right' />
                  </BrButton>
                ) : (
                  !hasErrorGetCnpjNaturezaId &&
                  !isCnpjFilial && (
                    <Link to='/titular-ou-arrendatario'>
                      Acessar <i className='fas fa-arrow-right' />
                    </Link>
                  )
                )}
              </div>
            </BrCard>

            {isLoadingCnpjNaturezaId && <CustomLoading label='Verificando natureza do CNPJ...' />}

            <BrCard
              className={styles.card}
              onClick={() => {
                if (hasErrorGetCnpjNaturezaId) {
                  notificarErroConsultaApiCnpj();
                  return;
                } else if (isCnpjFilial) {
                  setMostraAvisoFilial(true);
                } else if (isPrimeiroAdquirente) {
                  navigate('/primeiro-adquirente');
                } else {
                  notificarErroPrimeiroAdquirente();
                }
              }}
              hover
            >
              <h2 className={styles.cardTitle}>Primeiro Adquirente</h2>
              <img src={primeiroAdquirenteImage} alt='' />
              <p className={styles.cardText}>
                O <strong>primeiro adquirente</strong> é a pessoa que realiza a primeira aquisição de um bem mineral
                extraído sob o regime de permissão de lavra garimpeira.
              </p>
              <div className={styles.cardLink}>
                {!isCnpjFilial && !hasErrorGetCnpjNaturezaId && isPrimeiroAdquirente ? (
                  <Link to={'/primeiro-adquirente'}>
                    Acessar <i className={`fas fa-arrow-right`} />
                  </Link>
                ) : !hasErrorGetCnpjNaturezaId && isCnpjFilial ? (
                  <BrButton onClick={() => setMostraAvisoFilial(true)}>
                    Acessar <i className={`fas fa-arrow-right`} />
                  </BrButton>
                ) : hasErrorGetCnpjNaturezaId ? (
                  <BrButton onClick={() => notificarErroConsultaApiCnpj()}>
                    Acessar <i className={`fas fa-arrow-right`} />
                  </BrButton>
                ) : (
                  !isPrimeiroAdquirente && (
                    <BrButton
                      data-testid='primeiroAdquirenteAcessarBtn'
                      onClick={() => notificarErroPrimeiroAdquirente()}
                    >
                      Acessar <i className={`fas fa-arrow-right`} />
                    </BrButton>
                  )
                )}
              </div>
            </BrCard>

            <BrCard className={styles.card} onClick={acessarHastaPublica} hover>
              <h2 className={styles.cardTitle}>Arrematação em Hasta Pública</h2>
              <img src={arrematacaoImage} alt='' />
              <p className={styles.cardText}>
                A <strong>arrematação em hasta pública</strong> é um procedimento de leilão público no qual são
                oferecidos bens minerais apreendidos. A pessoa (arrematante) que adquire o bem mineral ofertado em hasta
                pública fica obrigada ao pagamento da CFEM nos termos na Lei.
              </p>
              <div className={styles.cardLink}>
                <BrButton
                  data-testid='hastaPublicaAcessarBtn'
                  onClick={() => {
                    acessarHastaPublica();
                  }}
                >
                  Acessar <i className={`fas fa-arrow-right`} />
                </BrButton>
              </div>
            </BrCard>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      {renderContent()}

      <Modal
        title='Declarante cadastrado como Titular ou Arrendatário'
        useScrim
        modalOpened={isModalTitularArrendatario}
      >
        <Modal.Body>
          Você está cadastrado como <strong>Titular ou Arrendatário</strong>. Deseja mesmo assim prosseguir para
          declarar arrematações em Hasta Pública?
        </Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button secondary small m={2} onClick={() => setIsModalTitularArrendatario(false)}>
            Cancelar
          </Button>
          <Button
            primary
            small
            m={2}
            onClick={() => {
              setIsModalTitularArrendatario(false);
              navigate('/hasta-publica');
            }}
          >
            Continuar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        title='Declaração de Titular ou Arrendatário ou Primeiro Adquirente devem ser realizadas pelo CNPJ matriz.'
        useScrim
        modalOpened={mostraAvisoFilial}
      >
        <Modal.Body>
          <p>
            A declaração da DIEF-CFEM para <strong>Pessoas Jurídicas</strong> deve ser consolidada e enviada
            exclusivamente pelo <strong>CNPJ do estabelecimento matriz</strong>. Seu acesso atual está operando em nome
            de um CNPJ de filial. Para prosseguir, retorne e selecione a opção de <strong>CNPJ Representado</strong>{' '}
            para operar em nome da <strong>matriz</strong>. Caso o CNPJ da matriz não esteja aparecendo como uma opção,
            verifique se seu acesso gov.br (Nível Prata ou superior) está corretamente associado ao e-CNPJ da matriz na
            plataforma gov.br.
          </p>
        </Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button
            className='br-button primary'
            type='button'
            onClick={() => {
              setMostraAvisoFilial(false);
            }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DiefCfemCards;
